import React from 'react';
import {
  BooleanInput,
  FormDataConsumer,
  TextInput,
} from 'react-admin';
import _ from 'lodash';

export default props => (
  <div>
    <BooleanInput
      label="Disable Bank Linkage in Funnel"
      source="appConfig.bankLink.disableInFunnel"
      style={{ width: '100%' }}
      {...props}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData &&
        formData.appConfig &&
        formData.appConfig.bankLink &&
        formData.appConfig.bankLink.disableInFunnel &&
        <TextInput
          label="Funnel Alert Text"
          source="appConfig.bankLink.funnelDisclaimer"
          multiline
          minRows={1}
          maxRows={4}
          style={{ width: '100%' }}
          {...rest}
          validate={value => (_.isEmpty(value) ? 'A disclaimer text needs to be provided' : null)}
        />
        }
    </FormDataConsumer>
    <BooleanInput
      label="Disable Bank Linkage in Mobile"
      source="appConfig.bankLink.disableInMobile"
      style={{ width: '100%' }}
      {...props}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData &&
        formData.appConfig &&
        formData.appConfig.bankLink &&
        formData.appConfig.bankLink.disableInMobile &&
        <TextInput
          label="Mobile Alert Text"
          source="appConfig.bankLink.mobileDisclaimer"
          multiline
          minRows={1}
          maxRows={4}
          style={{ width: '100%' }}
          {...rest}
          validate={value => (_.isEmpty(value) ? 'A disclaimer text needs to be provided' : null)}
        />
        }
    </FormDataConsumer>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Config/BankLinkConfig.jsx